import script from "./FundingReports.vue?vue&type=script&setup=true&lang=ts"
export * from "./FundingReports.vue?vue&type=script&setup=true&lang=ts"

import "./FundingReports.vue?vue&type=style&index=0&id=346eefc2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-346eefc2"]])

export default __exports__